import { AppStore } from '../models/Store';
import { GetItemById, getItemByIdSelector } from '../reducers/items/itemsSelectors';
import { Item } from '@ael/core-api';
import { createSelector } from 'reselect';

const getCurrentItemId: (store: AppStore) => string | null = (state) => state.currentItem;

export const getCurrentItem: (store: AppStore) => Item | null = createSelector(
  [getCurrentItemId, getItemByIdSelector],
  (currentItemId: string | null, getItemById: GetItemById) => {
    if (!currentItemId) {
      return null;
    }
    return getItemById(currentItemId);
  }
);
